import { shift } from '@floating-ui/react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BindModalContent } from 'widgets/broadcast';
import { EElementSize } from 'shared/types';
import { Button, ConnectIcon, EButtonType } from 'shared/ui';
import { DropDown, DropDownProvider } from 'shared/ui/drop-down';
import { IBindEventsProps } from './bind-events.types';

export const BindEvents: FC<IBindEventsProps> = ({ broadcast }) => {
  const { t } = useTranslation();

  const floatingMiddlewares = useMemo(
    () => [
      shift({
        crossAxis: true,
      }),
    ],
    [],
  );

  return (
    <DropDownProvider>
      <DropDown
        middlewares={floatingMiddlewares}
        placement="bottom-start"
        offset={8}
        useParentWidth={false}
        content={<BindModalContent broadcast={broadcast} />}
      >
        <Button
          $type={EButtonType.GHOST_GRAY}
          $size={EElementSize.S}
          prependIcon={<ConnectIcon />}
        >
          {t('bind event')}
        </Button>
      </DropDown>
    </DropDownProvider>
  );
};
